import styles from './AccountLayout.module.css';

interface Props {
  short?: boolean;
}

const AccountDivider = ({ short = false }: Props) => (
  <hr className={short ? styles.Short : ''} />
);

export default AccountDivider;
